import type { FaireProductEntity } from "../../entity_types/product";

export const p_nr5bfs6pp5: FaireProductEntity = {
  token: "p_nr5bfs6pp5",
  type: "product",
  name: "NEVER COMPLICATED - Duo Color Heel, Girl Boss Vibes✈️TODAY",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/61d633cfff9c77135e6d01a63e5a1e81d8ec79e77bf2e06d235538cdc1ef6d3c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/72b206c4bed3fade2f5d38b15547dcef98d02f345703105e7aa1f91343239ad1.jpeg",
    "https://cdn.faire.com/fastly/996847622ccba3706034e451ada7d697180abddf6c3afd89b57fa07d804ce1c5.jpeg",
    "https://cdn.faire.com/fastly/ccb87bf56c70b8c4f1bfa7931e5e771559c5f4c4adcbd71b35b1c18526cec037.jpeg",
    "https://cdn.faire.com/fastly/608898d075380d426ce265f035f61970e121787983b610aec70888b379343649.jpeg",
    "https://cdn.faire.com/fastly/22460791777cacce990092c5b0e9ac0dc51028aa03d5e763d4912e187e33cf65.jpeg",
    "https://cdn.faire.com/fastly/7ebabc9332598c27e56283ebdb86adbafd8ed78d5158fece76e1a1946ca91736.jpeg",
    "https://cdn.faire.com/fastly/e9313ba790088de4575051b52ffb4b3e26469be24910c0b40df7764f24f3e5b7.jpeg",
    "https://cdn.faire.com/fastly/7c79470e8a4f2aaf7a26842c0b77ac5beedc78c29a27e8e65113d1643ba8d273.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
  ],
  priceDollars: 12,
  description:
    "NEVER COMPLICATED is a refined thong heel with a rich mix of texture and shape. This elevated sandal features a soft suede body paired with a croc-embossed upper for subtle contrast and depth. Finished with slim straps and a sculptural heel, it blends classic lines with modern detail for a look that feels both polished and distinctive. Sophisticated, wearable, and quietly statement-making.\n\nAvailable in Black, Chocolate, Light Blue, and Taupe\n\n𝐎𝐎𝐓𝐃\nStyle with tailored trousers and a silky blouse for an effortlessly elevated look, or pair with a slip skirt and cropped knit for something softer and more feminine. Add a sleek shoulder bag and minimal jewelry to let the mixed textures stand out — chic, confident, and easy to wear from day to night.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:10.949Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
